<template>
    <div>
        <div id="edit_media_list" class="cic-popup">
            <ul class="cic-container">
                <li class="cic-popup-body">
                    <div v-if="$store.mediaLoading === 'all'" class="cloud-overlay"></div>
                    <div v-if="$store.hasRight('bEditMedia')" class="media-panel">
                        <div class="cic-header">
                            <span class="cic-header-title">{{ $t('Media Source') }}</span>
                        </div>
                        <ul v-if="!orgList" class="item-form">
                            <li>
                                <CicSelect
                                    id="media_source"
                                    :value="source"
                                    :options="sourceOptions"
                                    @input="handleSource"
                                />
                            </li>
                            <template v-if="['upload', 'tts'].includes(source)">
                                <li class="form-label">
                                    {{ $t('Overwrite Media') }}
                                </li>
                                <li>
                                    <CicCheckbox
                                        id="media_overwrite"
                                        :value="overwrite"
                                        @input="(val) => (overwrite = val)"
                                    />
                                </li>
                            </template>
                        </ul>
                        <UploadMedia
                            v-if="source === 'upload'"
                            class="media-stretch"
                            :extensions="extensions"
                            :max-file-size="maxFileSize"
                            :max-queue-length="maxQueueLength"
                            :media-list-id="item.mediaListId"
                            :org-list="orgList"
                            @change="(val) => $emit('distribute', val, overwrite)"
                        />
                        <CreateMedia
                            v-else-if="source === 'tts'"
                            :voice-models="voiceModels"
                            class="media-stretch"
                            @change="(val) => $emit('distribute', val, overwrite)"
                        />
                        <template v-else>
                            <div v-if="$store.mediaLoading === 'left'" class="cloud-overlay"></div>
                            <CopyMedia
                                v-else
                                :media="sourceList.media"
                                class="media-stretch"
                                @change="(val) => $emit('copy', source, val)"
                            />
                        </template>
                    </div>
                    <div v-if="$store.hasRight('bEditMedia')" class="panel-divider"></div>
                    <div id="media_destination" class="media-panel">
                        <div class="cic-header">
                            <span class="cic-header-title">{{ $t('Media Destination') }}</span>
                        </div>
                        <ul v-if="$store.hasRight('bEditMedia')" class="item-form">
                            <li>
                                <CicSelect
                                    id="media_dest_list"
                                    :value="item.mediaListId"
                                    :options="lists.map((x) => ({ value: x.mediaListId, label: x.name }))"
                                    @input="(val) => $emit('reload', val, true)"
                                />
                            </li>
                        </ul>
                        <div v-if="$store.mediaLoading === 'right'" class="cloud-overlay"></div>
                        <EditMedia
                            v-if="item.media"
                            v-show="$store.mediaLoading !== 'right'"
                            :media="item.media"
                            :media-list-id="item.mediaListId"
                            class="media-stretch"
                            @change="$emit('reload', item.mediaListId, true, true)"
                        />
                    </div>
                </li>
                <li class="cic-footer">
                    <CicButton id="popup_cancel" @click="$emit('blur')">
                        {{ $t('Cancel') }}
                    </CicButton>
                </li>
            </ul>
        </div>
        <div class="cic-overlay" @click="$emit('blur')"></div>
    </div>
</template>

<script>
    import CicButton from '@/components/CicButton';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicSelect from '@/components/inputs/CicSelect';
    import CreateMedia from './CreateMedia';
    import CopyMedia from './CopyMedia';
    import UploadMedia from './UploadMedia';
    import EditMedia from '@/feature/mediaLists/EditMedia';

    export default {
        name: 'EditMediaList',
        components: {
            CicButton,
            CicCheckbox,
            CicSelect,
            CopyMedia,
            CreateMedia,
            EditMedia,
            UploadMedia,
        },
        props: {
            disableStreaming: {
                type: Boolean,
                default: false,
            },
            extensions: {
                type: Array,
                required: true,
            },
            item: {
                type: Object,
                required: true,
            },
            lists: {
                type: Array,
                required: true,
            },
            maxFileSize: {
                type: Number,
                default: 10,
            },
            maxQueueLength: {
                type: Number,
                default: 10,
            },
            orgList: {
                type: Boolean,
                default: false,
            },
            voiceModels: {
                type: Array,
                required: true,
            },
        },
        emits: ['blur', 'copy', 'distribute', 'reload'],
        data() {
            return {
                overwrite: false,
                source: 'upload',
            };
        },
        computed: {
            sourceList() {
                return this.lists.find((x) => x.mediaListId === this.source);
            },
            sourceOptions() {
                const options = [{ value: 'upload', label: this.$t('Upload Media') }];
                if (this.$store.hasRight('CREATE_TTS_MEDIA')) {
                    options.push({ value: 'tts', label: this.$t('New Prompt') });
                }

                return options.concat(this.lists.map((x) => ({ value: x.mediaListId, label: x.name })));
            },
        },
        methods: {
            handleSource(val) {
                this.source = val;
                if (!['upload', 'tts'].includes(val)) {
                    this.$emit('reload', val, false);
                }
            },
        },
    };
</script>
